import { Stack, Heading, Alert, AlertDescription } from '@chakra-ui/react'
import RoleRequestCard from './RoleRequestCard'
import { PiChalkboardTeacher } from 'react-icons/pi'
import { RiParentLine } from 'react-icons/ri'
import { useAuth } from '@/shared/context/AuthContext'

export default function RoleRequestSection() {
    const { refreshProfile } = useAuth()
    return (
        <Stack spacing={6} maxW={'md'}>
            <Heading size="sm" mt="1em">
                Request Additional Roles
            </Heading>
            <Alert status="warning" borderRadius={'md'}>
                <AlertDescription>
                    Request role with great caution to avoid ban!
                </AlertDescription>
            </Alert>
            <Stack spacing={6}>
                <RoleRequestCard
                    title="Parent"
                    description="Request access to parent features including child progress registeration, coparent management, and activity tracking."
                    icon={<RiParentLine size={24} />}
                    role="parent"
                    onSuccess={refreshProfile}
                />
                <RoleRequestCard
                    title="Teacher"
                    description="Request access to teacher features including checking-in and checking-out children, queue management and reporting"
                    icon={<PiChalkboardTeacher size={24} />}
                    role="teacher"
                    onSuccess={refreshProfile}
                />
            </Stack>
        </Stack>
    )
}
